import { CALENDAR_EVENT_TYPES } from '@/app/(main)/calendar/consts/calendar-event-types';
import { CALENDAR_TASK_DISPLAY_TITLE_PREFIX } from '@/app/(main)/calendar/consts/calendar-task-display-title';
import type { CalendarEvent } from '@/types/calendarTypes';

const BIRTHDAY_TITLE_SUFFIX = '\'s birthday';

function formatBirthdayDisplayTitle(title: string): string {
  if (title.endsWith(BIRTHDAY_TITLE_SUFFIX)) {
    return title.slice(0, -BIRTHDAY_TITLE_SUFFIX.length);
  }

  return title;
}

export function formatCalendarEventDisplayTitle(event: Pick<CalendarEvent, 'type' | 'title'>): string {
  if (event.type === CALENDAR_EVENT_TYPES.BIRTHDAY) {
    return formatBirthdayDisplayTitle(event.title);
  }

  if (event.type === CALENDAR_EVENT_TYPES.TASK_REMINDER) {
    return `${CALENDAR_TASK_DISPLAY_TITLE_PREFIX.REMINDER} ${event.title}`;
  }

  if (event.type === CALENDAR_EVENT_TYPES.TASK_DEADLINE) {
    return `${CALENDAR_TASK_DISPLAY_TITLE_PREFIX.DEADLINE} ${event.title}`;
  }

  return event.title;
}
